import { ModuleEnrichmentRunner } from '@/services/moduleEnrichments'

export default {
  data: () => ({ enrichmentLoading: false, enrichmentError: '' }),
  created() { this._moduleEnrichmentRunner = new ModuleEnrichmentRunner() },
  beforeDestroy() { this.cancelModuleEnrichments() },
  methods: {
    // Les données restent visibles pendant le calcul complémentaire.
    cancelModuleEnrichments() {
      if (this._moduleEnrichmentRunner) this._moduleEnrichmentRunner.invalidate()
      this.enrichmentLoading = false
      this.enrichmentError = ''
    },
    enrichModuleRows(rows, config, context = {}) {
      this.enrichmentError = ''
      return this._moduleEnrichmentRunner.run({
        rows, configs: config, moduleId: this.idmodule, api: request => this.API(request),
        token: context.token, params: context.params, querys: context.querys,
        set: (row, key, value) => this.$set(row, key, value),
        onLoading: value => { this.enrichmentLoading = value },
        onError: message => { this.enrichmentError = message },
      })
    },
  },
}
